import { useEffect } from "react";

export function useKey(key, action) {
  useEffect(
    function () {
      function callback(e) {
        if (e.code.toLowerCase() === key.toLowerCase()) action();
      }
      document.addEventListener("keydown", callback);

      return function cleanup() {
        document.removeEventListener("keydown", callback);
      };
    },
    [key, action]
  );
}
